const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrowB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1519.55 103.18a.602.602 0 0 1 .86 0c.23.233.23.62 0 .851l-4.34 4.362h14.33a.607.607 0 0 1 0 1.213h-14.33l4.34 4.353c.23.241.23.628 0 .86a.602.602 0 0 1-.86 0l-5.37-5.393a.594.594 0 0 1 0-.852l5.37-5.394Z",
    style: {
      fill: "fill:rgb(79,79,79)",
      fillRule: "nonzero"
    },
    transform: "translate(-1514 -103)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowB);
export default __webpack_public_path__ + "static/media/back-arrow-b.dc2a16c1baecb2822cc8a49ad8a2d97d.svg";
export { ForwardRef as ReactComponent };